import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { backend } from "../../services/backend";
import { useParams } from "react-router-dom";
import ClientInfoPanel from "../../components/detail/infoPanel";
import PreloaderPage from "../../pages/preloader";
import ClientEventsPanel from "../../components/detail/eventsPanel";
import { statsBackend } from "../../services";
import { toast } from "sonner";
import ErrorPage from "../../pages/error";

const ClientsDetailPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const { clientid } = useParams();
  const [update, triggerUpdate] = useState(true);
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [failed, setFailed] = useState(false)

  const session = State.session;
  const stateUpdate = State.selectedItem;

  useEffect(() => {
    backend
      .getCustomerFullData(Number(clientid))
      .then((res) => {
        dispatch(actions.customerDisplayData(res.data));
      })
      .catch((e) => {
        console.log(e.error || e);
        setFailed(true);
      });
  }, [update, stateUpdate]);

  if (!State.customerDetail) {
    return <PreloaderPage />;
  }

  if (failed)  {
    return <ErrorPage code={403} message="Нет прав на данного клиента" />;
  }

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="flex between w100 panelColumnFull">
          <ClientInfoPanel data={State.customerDetail} />
          <ClientEventsPanel data={State.customerDetail} />
        </div>
      </div>
    </PanelPage>
  );
};

export default ClientsDetailPage;
